export const depositConstant = {
  UPDATE_DEPOSIT_SUBMISSION: 'UPDATE_DEPOSIT_SUBMISSION'
};